export default __webpack_public_path__ + "static/media/waist-measurement.d2e60007.svg";